/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompetenzaMeseAnnoOutputDtoFromJSON, CompetenzaMeseAnnoOutputDtoToJSON, } from './CompetenzaMeseAnnoOutputDto';
/**
 * Check if a given object implements the CompetenzaFattureOutpuDto interface.
 */
export function instanceOfCompetenzaFattureOutpuDto(value) {
    return true;
}
export function CompetenzaFattureOutpuDtoFromJSON(json) {
    return CompetenzaFattureOutpuDtoFromJSONTyped(json, false);
}
export function CompetenzaFattureOutpuDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fkRowFattura': json['fkRowFattura'] == null ? undefined : json['fkRowFattura'],
        'idUtenteIntranet': json['idUtenteIntranet'] == null ? undefined : json['idUtenteIntranet'],
        'idProject': json['idProject'] == null ? undefined : json['idProject'],
        'idOrdine': json['idOrdine'] == null ? undefined : json['idOrdine'],
        'nominativo': json['nominativo'] == null ? undefined : json['nominativo'],
        'rate': json['rate'] == null ? undefined : json['rate'],
        'allPrj': json['allPrj'] == null ? undefined : json['allPrj'],
        'listAllocation': json['listAllocation'] == null ? undefined : (json['listAllocation'].map(CompetenzaMeseAnnoOutputDtoFromJSON)),
    };
}
export function CompetenzaFattureOutpuDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fkRowFattura': value['fkRowFattura'],
        'idUtenteIntranet': value['idUtenteIntranet'],
        'idProject': value['idProject'],
        'idOrdine': value['idOrdine'],
        'nominativo': value['nominativo'],
        'rate': value['rate'],
        'allPrj': value['allPrj'],
        'listAllocation': value['listAllocation'] == null ? undefined : (value['listAllocation'].map(CompetenzaMeseAnnoOutputDtoToJSON)),
    };
}
